import React from 'react';

const AsyncMailerMonitoring = React.lazy(() => import('./MailerMonitoringContainer'));
export const MailerMonitoringPage = () => {
  return <AsyncMailerMonitoring />;
};
